import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ChangeAvatarComponent } from '@core/components/change-avatar/change-avatar.component';
import { ChangePasswordComponent } from '@core/components/change-password/change-password.component';
import { toLevel } from '@interfaces';
import { Subject } from 'rxjs';
var TabGeneralComponent = /** @class */ (function () {
    function TabGeneralComponent(materialDialog, authenticationService) {
        this.materialDialog = materialDialog;
        this.authenticationService = authenticationService;
        this.reloadPage = new Subject();
        this.currentUserLevel = 0;
        this.isUpdate = false;
        this.imageHover = false;
        this.isOnEditDialog = false;
        this.avatarImagePayload = null;
        this.hasUsersEditPermission = false;
        this.isNewUser = false;
    }
    TabGeneralComponent.prototype.ngOnInit = function () {
        this.hasUsersEditPermission = this.authenticationService.hasPermission('users-edit');
        this.isOnEditDialog = !!(this.user.id);
        this.currentUserLevel = toLevel(this.currentUser.role);
        this.user.authenticationInfo = this.user.authenticationInfo || {};
        this.user.authenticationInfo.status = this.user.authenticationInfo.status || 'UNKNOWN';
        this.user.authenticationInfo.enabled =
            typeof this.user.authenticationInfo.enabled === 'boolean'
                ? this.user.authenticationInfo.enabled
                : 'UNKNOWN';
        if (this.user['id']) {
            this.isNewUser = true;
        }
    };
    TabGeneralComponent.prototype.openChangePasswordDialog = function () {
        var _this = this;
        this.materialDialog
            .open(ChangePasswordComponent, {
            panelClass: 'change-password-dialog',
            autoFocus: true,
            data: this.user || null
        }).afterClosed().subscribe(function (value) {
            if (value && value.password) {
                _this.user['password'] = value.password;
            }
        });
    };
    TabGeneralComponent.prototype.openChangeAvatarDialog = function () {
        var _this = this;
        this.materialDialog
            .open(ChangeAvatarComponent, {
            panelClass: 'change-avatar-dialog',
            autoFocus: false,
            data: this.user.id || null
        }).afterClosed().subscribe(function (value) {
            if (value && value.avatarImagePayload && value.avatarImagePayload.imageBase64Encoded) {
                _this.avatarImagePayload = value.avatarImagePayload;
                _this.user.avatarUrl = value.avatarImagePayload.imageBase64Encoded;
                if (_this.isOnEditDialog) {
                    _this.reloadPage.next();
                }
            }
        });
    };
    return TabGeneralComponent;
}());
export { TabGeneralComponent };
